<template>
  <van-form ref="form" v-model="form">
    <van-field
        label="开始时间"
        is-link
        readonly
        v-model="form.xyworkstart"
        :show-error="true"
        :show-error-message="false"
        name="xyworkstart"
        :rules="[
        { required: true, message: '请填写在西亚工作开始的时间', trigger: 'on' },
      ]"
        @click="showWorkStart = true"
    />
    <van-popup v-model:show="showXyWorkStart" position="bottom">
      <van-datetime-picker
          type="year-month"
          :minDate="new Date(2000, 1, 1)"
          :maxDate="new Date()"
          @confirm="onXyWorkStartConfirm"
          @cancel="showXyWorkStart = false"
      >
      </van-datetime-picker>
    </van-popup>
    <van-field
        label="结束时间"
        is-link
        readonly
        v-model="form.xyworkend"
        name="xyworkend"
        @click="showXyWorkEnd = true"
        :rules="[{ required: true, message: '请填写在西亚工作结束的时间' }]"
    />
    <van-popup v-model:show="showXyWorkEnd" position="bottom">
      <van-datetime-picker
          type="year-month"
          :minDate="new Date(2000, 1, 1)"
          :maxDate="new Date()"
          @confirm="onXyWorkEndConfirm"
          @cancel="showXyWorkEnd = false"
      >
      </van-datetime-picker>
    </van-popup>
    <van-field
        label="门店/机构"
        v-model="form.organ"
        name="organ"
        maxlength="10"
        :rules="[{ required: true, message: '请填写店名/机构' }]"
    />
    <van-field
        label="部门"
        v-model="form.depart"
        name="depart"
        maxlength="18"
        :rules="[{ required: true, message: '请填写所在部门' }]"
    />
    <van-field
        label="职位"
        v-model="form.post"
        name="post"
        maxlength="10"
        :rules="[{ required: true, message: '请填写担任职位' }]"
    />
    <van-field
        label="离职原因"
        v-model="form.leave"
        name="leave"
        rows="2"
        type="textarea"
        maxlength="50"
        placeholder="请简单描述离职原因,不超过50字"
        :rules="[{ required: true, message: '请填写离职的原因' }]"
    />
  </van-form>
</template>
<script>
import { monthFormat } from '@/comm/comm.js'
export default {
    name:'EditXyWorkHis',
    props:{
        'xyWorkHisData':{
            type:Object,
            default: null,
            require: false
        }
    },
    data(){
        return{
            showXyWorkStart: false,
            showXyWorkEnd: false,
            form:{
              id: '',
              leave: "",
              post: "",
              depart: "",
              organ: "",
              xyworkend: "",
              xyworkstart: "",
            }
        }
    },
    watch:{
      xyWorkHisData:{
            handler(val){
                this.form = val
            },
            immediate: true,
            deep:true
        },
    },
    methods:{
        onXyWorkStartConfirm(res){
            this.showXyWorkStart = false
            this.form.xyworkstart = monthFormat(res)
        },
        onXyWorkEndConfirm(res){
            this.showXyWorkEnd = false
            this.form.xyworkend = monthFormat(res)
        },
        onReset(){
            this.$refs.form.resetValidation()
        },
        validateForm() {
            return this.$refs.form.validate()
        },
    }
}
</script>